import { watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
const EMAIL_CAMPAIGN_LIST_ROUTE_NAME = 'email-campaign-list';
export function useEmailCampaignListNavigation() {
    const router = useRouter();
    function goToList(createdId) {
        return router.push({
            name: EMAIL_CAMPAIGN_LIST_ROUTE_NAME,
            query: {
                refresh: String(Date.now()),
                ...(createdId ? { createdId } : {}),
            },
        });
    }
    return { goToList };
}
export function useEmailCampaignListRefresh(options) {
    const route = useRoute();
    const router = useRouter();
    watch(() => ({ refresh: route.query.refresh, createdId: route.query.createdId }), async ({ refresh }) => {
        if (!refresh)
            return;
        await options.setPage(1, options.state.pagination.limit);
        options.reload();
        router.replace({
            query: {
                ...route.query,
                refresh: undefined,
                createdId: undefined,
            },
        });
    }, { immediate: true });
}
